module.exports = __webpack_public_path__ + "static/media/ind_windows.053c7f99.png";